export function getUnpaidDetailsEndpoint(contractId: string): string {
    return `/contracts/${contractId}/unpaid-details`;
}
